import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/dot_net/banner_net.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service iphone_banner hire_net_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={9} lg={8} xl={8} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Hire .NET Developers
              </h1>
              <span style={{ color: "#000" }}>
                Hire the Top 3% of Freelance .NET Developers
              </span>
              <p style={{ color: "#000" }}>
                TekRevol is a premier marketplace connecting you with the
                industry's top .NET developers and coders. Leading CEOs, CTOs,
                and management teams from top companies and innovative startups
                partner with our .NET freelancers to enhance their development
                teams. Whether it's .NET development, application development,
                web development, or other software projects, TekRevol ensures
                you achieve your business objectives with expert precision.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Hire Professional .Net Developers
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
